import React, { useEffect, useState } from "react";
import "./about.css";
import { person } from "../../utils";
import Skills from "./Skills";
import WhatICanDo from "./WhatICanDo";

const About = () => {
  const [dots, setDots] = useState([]);

  useEffect(() => {
    // Generate random dots
    const newDots = [];
    for (let i = 0; i < 30; i++) {
      newDots.push({
        id: i,
        top: `${Math.random() * 100}%`,
        left: `${Math.random() * 100}%`,
        delay: `${Math.random() * 4}s`,
        duration: `${3 + Math.random() * 2}s`,
      });
    }
    setDots(newDots);
  }, []);

  return (
    <div id="about" className="about">
      {/* Background elements */}
      <div className="about-background">
        {/* Hexagon grid */}
        <div className="hexagon-grid"></div>

        {/* Geometric shapes */}
        <div className="geometric-container">
          <div className="geometric-shape shape-1"></div>
          <div className="geometric-shape shape-2"></div>
        </div>

        {/* Animated dots */}
        <div className="dots-container">
          {dots.map((dot) => (
            <div
              key={dot.id}
              className="dot"
              style={{
                top: dot.top,
                left: dot.left,
                animationDelay: dot.delay,
                animationDuration: dot.duration,
              }}
            ></div>
          ))}
        </div>
      </div>

      <div className="max-width">
        <div className="about_row">
          <div className="about_card">
            <img src={person} alt="me" />
            <div className="">
              <h3 className="fs-4">Hi, I’m Safi Nafi</h3>
              <p className="mb-0">
                With 2 years of experience, I have honed my skills in both
                frontend and backend dev, creating dynamic and responsive
                websites.
              </p>
            </div>
          </div>
          <div className="about_card">
            <Skills />
          </div>
          <div className="about_card size_two_height">
            <WhatICanDo />
          </div>
          <div className="about_card size_two_width">
            <p className="desc">
              I am a software engineer from Palestine, specializing in{" "}
              <span>website development</span>. My work includes both{" "}
              <span>front-end</span> and <span>back-end</span> development,
              creating seamless and interactive user experiences. Explore my
              portfolio to see the diverse range of websites and applications
              I've developed, showcasing my ability to deliver comprehensive web
              solutions.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
